import type { ReactNode } from 'react';

/** A plain "nothing here yet" panel — no keys, no usage, no search matches. */
export function EmptyState({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="empty-panel empty-panel--quiet">
      <p className="empty-title">{title}</p>
      {children}
    </div>
  );
}
